var MyMapId = 'pricemap-container';

$.getScript("//api-maps.yandex.ru/2.1/?apikey=5669d7f1-e453-47ba-97c3-dcebbe618242&lang=ru-RU").done(function() {
	ymaps.ready(create_map);
});


function create_map() {
	var myMap = new ymaps.Map(MyMapId, {
		center: [55.76, 37.64], // ������
		zoom: 9,
		controls: ['zoomControl', 'fullscreenControl']
	}, {
		searchControlProvider: 'yandex#search'
	});

	var customItemContentLayout = ymaps.templateLayoutFactory.createClass(
		'<a href="{{ properties.url }}" target="_blank" class="pricemap-baloon pricemap-cluster-baloon">' +
			'<span class="pricemap-bg" style="background-image:url({{ properties.img }})"></span>' +
			'<span class="pricemap-content">' +
				'<span class="pricemap-baloon-header">{{ properties.name|raw }}</span>' +
				'<span>{{ properties.priceStr|raw }}</span>' +
			'</span>' +
		'</a>'
	);

	var clusterer = new ymaps.Clusterer({
		preset: 'islands#redClusterIcons',
		clusterIcons: [{
				href: '/assets/img/pricemap-icon.png',
				size: [86, 49],
				offset: [-4, 0]
			}],
		gridSize: 128,
		groupByCoordinates: false,
		zoomMargin: 50,
		clusterBalloonContentLayoutHeight: 200,
		clusterBalloonContentLayoutWidth: 200,
		clusterDisableClickZoom: true,
		clusterHideIconOnBalloonOpen: true,
		clusterIconContentLayout: ymaps.templateLayoutFactory.createClass('<div class="pricemap-label">$[properties.price]</div>'),
		geoObjectHideIconOnBalloonOpen: false,
		//clusterBalloonContentLayout: customClusterBaloonLayout
		clusterBalloonContentLayout: 'cluster#balloonCarousel',
		clusterBalloonItemContentLayout: customItemContentLayout
	});

	myMap.behaviors.disable('scrollZoom');
	myMap.behaviors.disable('drag');



	var jqxhr = $.getJSON('/s_ajax_pricemap.php', function(data) {
		$.each(data.markers, function(i, marker) {
			var placemarker = new ymaps.Placemark([marker.lat, marker.lng], {
				name:	marker.name,
				url:	marker.url,
				price:	marker.price,
				img:	marker.img,
				priceStr:	marker.price_formatted
			}, {
				balloonContentLayout: customItemContentLayout,
				hideIconOnBalloonOpen: false,
				iconContentLayout: ymaps.templateLayoutFactory.createClass('<div class="pricemap-label">$[properties.priceStr]</div>'),
				iconContentSize: [86, 38],
				iconLayout: 'default#imageWithContent',
				iconImageHref: '/assets/img/pricemap-icon.png',
				iconImageSize: [86, 49],
				iconImageOffset: [-4, -49]
			});

			clusterer.add(placemarker);
		});

		myMap.geoObjects.add(clusterer);

		clusterer.events.add('mapchange', function(e) {
			setClusterLabels();
		});

		myMap.events.once('mousedown', function(e){
			myMap.behaviors.enable('scrollZoom');
			myMap.behaviors.enable('drag');
			return true;
		});

		myMap.events.add('boundschange', function(e) {
			if (e.get('oldZoom') != e.get('newZoom')) {
				setClusterLabels();
			}
		});
		setClusterLabels();
	});
	jqxhr.fail(function(d, textStatus, error) {
		console.error("getJSON failed, status: " + textStatus + ", error: " + error);
	});

	var setClusterLabels = function() {
		var clusters = clusterer.getClusters();
		for (var i = 0; i < clusters.length; i++) {
			var objects = clusters[i].getGeoObjects();
			var minIndex = 0;
			var minPrice = objects[0].properties.get('price');
			for (var j = 1; j < objects.length; j++) {
				var price = objects[j].properties.get('price');
				if (price < minPrice) {
					minPrice = price;
					minIndex = j;
				}
			}
			clusters[i].properties.set('price', objects[minIndex].properties.get('priceStr'));
		}
	};
}
